class BxfPopoverConstants {
    static COMPONENT_NAME = 'bxf-popover';
    static STRING = {
        BXF_POPOVER: 'bxf-popover',
        BXF_LEARN_LINK: 'bxf-learn-link',
        BXF_CONTENT: 'bxf-popover__content',
        BXF_INNER_CONTENT: 'bxf-popover__content--inner',
        BXF_INNER_CONTENT_CLOSE: 'bxf-popover__content--inner-close',
        HEADER_CONTAINER: 'bxf-popover__header-container',
        HEADER: 'bxf-popover__header',
        BXF_TARGET: 'bxf-popover__target',
        CLOSE_BUTTON: 'bxf-popover__close-button',
        CLOSE_BUTTON_WRAPPER: 'bxf-popover__close-button-wrapper',
        WHITE_BACKGROUND_COLOR: 'bxf-popover__white-color',
        DELETE_ICON: 'delete-small',
        PATH: 'path',
        CLASSNAME: 'className',
        MOUSEDOWN: 'mousedown',
        CLICK: 'click',
        MOUSEOVER: 'mouseover',
        MOUSEOUT: 'mouseout',
        RESIZE: 'resize',
        DATA_POINT: 'bxf-popover__datapoint',
        DATA_POINT_CONTENT: 'bxf-popover__content__datapoint',
        CONTAINER: 'bxf-popover__container',
        DATA_POINT_CONTAINER: 'bxf-popover__container__data-point',
        TARGET: 'target',
        CONTENT: 'content',
        CLOSE_ICON: 'delete-small',
        TAGNAME: 'tagName',
        SCROLL: 'scroll',
        DATA_POINT_CLASS: '__data-point',
        CLOSE_BUTTON_LABEL: 'Close',
    };
}

var BxfPopoverBackgroundColor;
(function (BxfPopoverBackgroundColor) {
    BxfPopoverBackgroundColor["WHITE"] = "white";
    BxfPopoverBackgroundColor["GRAY_10"] = "gray-10";
})(BxfPopoverBackgroundColor || (BxfPopoverBackgroundColor = {}));

export { BxfPopoverConstants as B, BxfPopoverBackgroundColor as a };
